import useAlertNavigation from './useAlertNavigation';
import useWhatsAppWarnings from './useWhatsAppWarnings';

const useAlertSummary = () => {
  useWhatsAppWarnings();
  const { handleAlertClick } = useAlertNavigation();

  return { handleAlertClick };
};

export default useAlertSummary;
